
export enum OrderSideEffectType {
  CreateReceipt = 'CreateReceipt',
  DeferOrderCompletion = 'DeferOrderCompletion',
  SendOnlyPaymentConfirmation = 'SendOnlyPaymentConfirmation',
  CreateTicketGiftCard = 'CreateGiftCard',
  CreateOpenTicketPass = 'CreateOpenTicketPass',
  CreateSingleOpenAccessPass = 'CreateOpenAccessPass', // do not change the enum value, we need it like this for backwards compatibility!
  CreateMultiOpenAccessPass = 'CreateMultiOpenAccessPass',
  CreateMultiGiftCard = 'CreateMultiGiftCard',
  CreateOpenAccessPassFromTicket = 'CreateOpenAccessPassFromTicket',
  RedirectAfterPayment = 'RedirectAfterPayment',
  SendProductOrderConfirmationEmail = 'SendProductOrderConfirmationEmail',
  GenerateProductQr = 'GenerateProductQr',
  GenerateProductPdf = 'GenerateProductPdf',
  OutboundWebhook = 'OutboundWebhook',
}
